import styled from 'styled-components';

import React from 'react';

const Div = styled.div`
    color: ${(props) => props.theme.secondaryFontColor};
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;
const SubtextLarge = ({ children , className }) => {
    return <Div className={className}>{children}</Div>;
};

export default SubtextLarge;
